<script setup>
import { ref } from 'vue';
import { useMainStore } from '../../../stores/index';
import ModalBase from './ModalOverlay.vue';

const Store = useMainStore();
const viewDocument = ref(null);

const responsableTask = ref(Store.user);
const responsableTaskEdit = ref([]);
const edit = ref(false);

const openModal = () => {
  edit.value = false;
  if (viewDocument.value) viewDocument.value.openModal();
};

const openModalEdit = () => {
  edit.value = true;
  responsableTaskEdit.value = Store.EditresponsableTask;
  if (viewDocument.value) viewDocument.value.openModal();
};

const ChangeResponsable = () => {
  Store.responsableTask = responsableTask.value;
  if (viewDocument.value) viewDocument.value.closeModal();
};

const EditChangeResponsable = () => {
  Store.EditresponsableTask = responsableTaskEdit.value;
  if (viewDocument.value) viewDocument.value.closeModal();
};

defineExpose({
  openModal,
  openModalEdit
});
</script>

<template>
  <div>
    <ModalBase ref="viewDocument">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <span class="font-docs"><b>Editar responsável pela tarefa</b></span>
          </div>
          <div>
            <button
              id="close"
              type="button"
              class="close"
              @click="viewDocument.closeModal()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>

      <template #body>
        <div v-if="!edit">
          <Dropdown
            v-model="responsableTask"
            :options="Store.users"
            filter
            optionLabel="name"
            placeholder="Selecione um responsável"
            style="z-index: 9999 !important; height: calc(4rem + 2px);"
            class="w-full my_form"
          >
            <template #value="slotProps">
              <div class="d-flex align-items-center" v-if="slotProps.value">
                <img :alt="slotProps.value.name" :src="$userAvatar(slotProps.value.path_image)" class="mr-2" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover;" />
                <div>{{ slotProps.value.name }}</div>
              </div>
            </template>
            <template #option="slotProps">
              <div class="d-flex align-items-center">
                <img :alt="slotProps.option.name" :src="$userAvatar(slotProps.option.path_image)" class="mr-2" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover;" />
                <div>{{ slotProps.option.name }}</div>
              </div>
            </template>
          </Dropdown>
        </div>

        <div v-if="edit">
          <Dropdown
            v-model="responsableTaskEdit"
            :options="Store.users"
            filter
            optionLabel="name"
            placeholder="Selecione um responsável"
            style="z-index: 9999 !important; height: calc(4rem + 2px);"
            class="w-full my_form"
          >
            <template #value="slotProps">
              <div class="d-flex align-items-center" v-if="slotProps.value">
                <img :alt="slotProps.value.name" :src="$userAvatar(slotProps.value.path_image)" class="mr-2" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover;" />
                <div>{{ slotProps.value.name }}</div>
              </div>
            </template>
            <template #option="slotProps">
              <div class="d-flex align-items-center">
                <img :alt="slotProps.option.name" :src="$userAvatar(slotProps.option.path_image)" class="mr-2" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover;" />
                <div>{{ slotProps.option.name }}</div>
              </div>
            </template>
          </Dropdown>
        </div>
      </template>

      <template #footer>
        <div class="d-flex justify-content-end mt-4">
          <button class="btn Color-Docs font-docs mr-3" style="border: 1px solid #F1860B" @click="viewDocument.closeModal()">
            Cancelar
          </button>
          <button v-if="!edit" class="btn background-Docs text-white font-docs" @click="ChangeResponsable">
            Salvar
          </button>
          <button v-if="edit" class="btn background-Docs text-white font-docs" @click="EditChangeResponsable">
            Salvar
          </button>
        </div>
      </template>
    </ModalBase>
  </div>
</template>